import React, { Component, PropTypes } from 'react';

class ReactSparkRadio extends Component {
    render() {
        return (
            <div className="row spark-toggle-group">
                <fieldset>
                    <label className="col-xs-12 spark-radio">
                        <input
                            className="spark-radio__input"
                            type="radio"
                            name={this.props.name}
                            value={this.props.value}
                            defaultChecked={this.props.checked}
                            onChange={this.props.onChange}
                            onClick={this.props.onClick}
                        />
                        <span className="spark-radio__box"></span>
                        <span className="spark-label">{this.props.label}</span>
                    </label>
                </fieldset>
            </div>
        );
    }
}

ReactSparkRadio.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onClick: PropTypes.func
};

export default ReactSparkRadio;



// WEBPACK FOOTER //
// ./src/components/widgets/ReactSparkRadio.js